import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';

/**
 * Single place for kiln-list vs landing routing and kiln-list tab layout breakpoints.
 */
@Injectable({
  providedIn: 'root',
})
export class ViewportService {
  /** At or below this width, use landing instead of kiln-list. */
  static readonly LANDING_MAX_WIDTH = 525;
  /** At or above this width, kiln-list uses horizontal tabs instead of a dropdown. */
  static readonly KILN_LIST_TABS_MIN_WIDTH = 1200;
  /** Width above which default home is Kiln List / Dashboard, not Quick Actions. */
  static readonly DEFAULT_LANDING_LARGE_MIN_WIDTH = 700;

  constructor(private platform: Platform) {}

  /** True when navigation should target kiln-list instead of landing. */
  shouldUseKilnListRoute(): boolean {
    return this.platform.width() > ViewportService.LANDING_MAX_WIDTH;
  }

  /** True when kiln-list should use the desktop split layout (not landing/mobile cards). */
  usesMobileKilnLayout(): boolean {
    return !this.shouldUseKilnListRoute();
  }

  /** True when kiln-list detail navigation should render as horizontal tabs. */
  usesKilnListTabBar(): boolean {
    return this.platform.width() >= ViewportService.KILN_LIST_TABS_MIN_WIDTH;
  }

  /** True when default home should be Kiln List or Dashboard rather than Quick Actions. */
  usesLargeScreenDefaultLanding(): boolean {
    return this.platform.width() > ViewportService.DEFAULT_LANDING_LARGE_MIN_WIDTH;
  }

  /** iPad/tablet orientation changes may swap between landing and kiln-list. */
  usesTabletOrientationRouting(): boolean {
    return this.platform.is('tablet');
  }
}
